/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.employee.timeline').directive('gccsEmployeeTimelineDayOff', () =>
  ({
    restrict: 'A',
    controller: 'EmployeeTimelineDayOffController',
    controllerAs: 'employeeTimelineDayOffCtrl',
    template: require('./template.pug'),
    scope: {
      onSave: '&'
    }
  })
);
